import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ScrollPositionService} from '../../services/scroll-position.service';
import {KenticoService} from '../../services/kentico.service';
import {Project} from '../../models/project';

@Component({
  selector: 'app-work',
  templateUrl: './work-list.component.html',
  styleUrls: ['./work-list.component.css'],
})
export class WorkListComponent implements OnInit, AfterViewInit {
  projects: Project[];

  constructor(private kenticoService: KenticoService,
              private spService: ScrollPositionService) {
    this.kenticoService.getProjects().subscribe(projects => this.projects = projects);
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.spService.autoScroll();
  }

  scrollPastHero() {
    this.spService.scrollPastHero();
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/pages/work-list/work-list.component.ts